import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Check, X, Rocket } from "lucide-react";

/**
 * Get-started checklist on the office Overview. Auto-hides when every
 * step is done; office can dismiss it permanently for the org.
 */
export function OnboardingChecklist() {
  const [data, setData] = useState(null);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    api.get("/onboarding/status").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data || hidden || data.dismissed || data.complete) return null;

  const dismiss = async () => {
    setHidden(true);
    try { await api.post("/onboarding/dismiss"); } catch { /* best-effort */ }
  };

  const pct = Math.round((data.done / data.total) * 100);

  return (
    <div className="hard-card p-5 mb-6 border-l-4 border-l-[#FF5F15]" data-testid="onboarding-checklist">
      <div className="flex items-start justify-between gap-3 mb-3">
        <div>
          <div className="label-tag flex items-center gap-1.5 mb-1">
            <Rocket className="w-3 h-3" /> Get set up
          </div>
          <div className="font-display font-bold uppercase tracking-tight">
            {data.done}/{data.total} done — you're {pct}% of the way there
          </div>
        </div>
        <button type="button" onClick={dismiss}
                className="text-zinc-400 hover:text-zinc-700 text-[10px] font-bold uppercase tracking-widest flex items-center gap-1 shrink-0"
                data-testid="onboarding-dismiss-btn">
          <X className="w-3.5 h-3.5" /> Hide
        </button>
      </div>

      <div className="h-1.5 bg-zinc-200 mb-4">
        <div className="h-full bg-[#FF5F15] transition-all" style={{ width: `${pct}%` }} />
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-2">
        {data.steps.map((s) => (
          <Link key={s.key} to={s.to}
                className={`flex items-center gap-2 p-2.5 border text-xs font-medium transition-colors ${
                  s.done
                    ? "bg-green-50 border-green-200 text-zinc-500"
                    : "bg-white border-zinc-300 hover:border-[#FF5F15]"
                }`}
                data-testid={`onboarding-step-${s.key}`}>
            <span className={`w-5 h-5 shrink-0 border-2 flex items-center justify-center ${
              s.done ? "bg-green-600 border-green-600 text-white" : "border-zinc-400"
            }`}>
              {s.done && <Check className="w-3.5 h-3.5" />}
            </span>
            <span className={s.done ? "line-through" : ""}>{s.label}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
